import e, { memo as p } from "react";
import { useTheme as u, Box as g, Text as E } from "@chakra-ui/react";
import { MarkDownReader as R } from "../../atoms/mark-down-reader/mark-down-reader.js";
const D = p(
  ({
    markdownContentBody: o,
    variantId: t = "MEDIUM",
    textColour: r = "BLACK",
    textAlignment: m = "left"
  }) => {
    const {
      common: {
        common04Regular: a,
        common02Regular: l,
        common01Regular: n
      },
      text: {
        default: c,
        onPrimary: s,
        deemphasized: x
      }
    } = u(), d = {
      BLACK: {
        color: c
      },
      WHITE: {
        color: s
      },
      DARK_GREY: {
        color: x
      }
    }, i = {
      SMALL: a,
      MEDIUM: l,
      LARGE: n
    };
    return /* @__PURE__ */ e.createElement(g, { "data-testid": "long-text" }, /* @__PURE__ */ e.createElement(
      E,
      {
        as: "span",
        className: "long-text-component",
        textAlign: m,
        sx: {
          ...i[t],
          ...d[r],
          a: {
            textDecoration: "underline"
          }
        }
      },
      /* @__PURE__ */ e.createElement(R, { markDown: o })
    ));
  }
);
export {
  D as LongText
};
